// analiticsApi.ts
import axios from 'axios';

const analiticsPost = async (
    tenantId: string, 
    mode: string, 
    userId: number, 
    payload: object,
): Promise<boolean> => {
    const res = await axios.post(import.meta.env.VITE_BASEURL +  '/api/rpc/sf_frontend_analitics_post', {
    // const res = await axios.post('https://dev-count.aipeeper.com/api/rpc/sf_frontend_analitics_post', {
        p_tenant_id: tenantId,
        p_mode: mode,
        p_user_id: userId,
        p_payload: payload,
    }, );
    return res.status == 204;
}

export const api = {
    analiticsPost
}